import { authRoles } from '@/core'
import { RouteRecordRaw } from 'vue-router'

const Referrals = () =>
  import(/* webpackChunkName: "login-view" */ './views/pages/index.vue')

export const referralsModuleRoutes: Array<RouteRecordRaw> = [
  {
    path: '/referrals',
    name: 'referrals',
    component: Referrals,
    meta: {
      title: 'Referidos',
      auth: {
        roles: Object.values(authRoles),
        redirect: '/auth/login',
        notFoundRedirect: { name: '/404' },
        forbiddenRedirect: '/404',
      },
    },
  },
]
